import generateWithAsyncActions from 'epic-alt-utils';
import {alt} from 'epic-react-common';

/**
 * SearchActions
 */

export default generateWithAsyncActions(alt, ['bingSearch'], []);
